export const FORM_ERROR_MESSAGES = {
  REQUIRED: "This field is required",
  EMAIL: "This field must be a valid email",
  STRING: "This field must be a valid string",
  STRING_MAX_LENGTH: (l) => `Max lenght ${l} symbols`,
  STRING_MIN_LENGTH: (l) => `Must be at least ${l} characters`,
  NUMBER_MAX_VALUE: (l) => `Min value is ${l}`,
  SHOULD_CONTAIN_AT_LEAST_ELEMENTS: (l) =>
    `Should contain at least ${l} element(s)`,
  PASSWORDS_NOT_SAME: "The passwords must be the same",
  PHONE_NUMBER:
    "Phone number is not valid. Supported formats: 1234567890, 123 456-7890, 123-456-7890",
  SAME_VALUES: "The two values should not be equal",
};
